<template>
	<v-container fluid pa-0 dark flat my-5>
		<v-layout row wrap class="inner-container" justify-center mx-5>
			<v-flex xs12 justify-center>
				<h1 class="mb-2">Preguntas Frecuentes</h1>
				<v-divider></v-divider>
			</v-flex>
		</v-layout>
		<v-layout row wrap class="inner-container" justify-center mx-5 mt-5>
			<v-flex xs12 justify-center>
			  <v-expansion-panel expand popout>
			    <v-expansion-panel-content
			      v-for="(item,i) in mantenedores.preguntas_frecuentes"
			      :key="i"
			      expand-icon="fas fa-chevron-down"
			    >
			      <div slot="header">
			        <div class="subheading"><b>{{item.pregunta}}</b></div>
			      </div>
			      <v-card>
			        <v-card-text v-html="item.respuesta"></v-card-text>
			      </v-card>
			    </v-expansion-panel-content>
			  </v-expansion-panel>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
	import { EventBus } from '../../events.js'
	import * as firebase from 'firebase/app'
	import 'firebase/firestore'
  export default {
  	name: 'Preguntas',
	title: 'Preguntas',
    data () {
      return {
        mantenedores: {}
      }
    },
    methods:{
			get_mantenedores(){
				let db = firebase.firestore()
				let self = this
				db.collection("mantenedores").doc("mantenedores").get().then(function(doc) {
						if (doc.exists) {
								self.mantenedores = doc.data()
						} else {
								// doc.data() will be undefined in this case
								console.log("No such document!");
						}
				}).catch(function(error) {
						console.log("Error getting document:", error);
				});

			}
    },
    mounted(){
    	this.get_mantenedores()
    }
  }
</script>